import * as stylex from "@stylexjs/stylex";
import Link from "next/link";
import { FormattedMessage } from "react-intl";
import { useRTL, useThemeNavigation } from "../hooks";
import * as M from "../materials";
import { breakpoints, colors } from "../materials/consts.stylex";
import { gridCenteredMaxWidthAreas, layout } from "../materials/layout.stylex";
import { typography } from "../materials/typography.stylex";
import { getThemeLabel } from "./article-switcher";
const stylexStyles = {
    root: {
        kZKoxP: "x1ymw6g",
        keoZOQ: "xdj266r",
        $$css: true
    },
    title: {
        kP9fke: "xn80e1m",
        kMwMTN: "xjvpvmj",
        $$css: true
    }
};
export const ArticleNavigation = ({ aliasRoute })=>{
    const isRTL = useRTL();
    const [prevTheme, nextTheme] = useThemeNavigation(aliasRoute);
    if (!prevTheme || !nextTheme) return null;
    const prevThemeStyle = M.themes[prevTheme];
    const nextThemeStyle = M.themes[nextTheme];
    return <div key="ArticleNavigation" {...stylex.props(layout.gridCenteredMaxWidth, stylexStyles.root)}>
      <div className="x1yedbjw x78zum5 x1qughib xamitd3 xh8yej3 x196nufh">
        <Link href={`/articles/${prevTheme}`}>
          <div {...{
        0: {
            className: "xh8yej3 x6s0dn4 x1ypdohk xl56j7k x14p003w xemqna3 xdpxx8g x15zctf7 x1s85apg xjmiiu8"
        },
        1: {
            className: "xh8yej3 x6s0dn4 x1ypdohk xl56j7k x14p003w xemqna3 x1hr2gdg x15zctf7 x1s85apg xjmiiu8"
        }
    }[!!isRTL << 0]}>
            <div className="x1ag4ua x196nufh">
              <FormattedMessage id="Previous theme" defaultMessage="Previous theme"/>
              <div {...stylex.props(typography.heading1, stylexStyles.title)}>{getThemeLabel(prevTheme)}</div>
            </div>
            {prevThemeStyle.kind === "article" && <img src={prevThemeStyle.illustration} alt="" className="x13oubkp x2sfjvx x1pqv317"/>}
          </div>
        </Link>

        <span className="xgc0pbm x18bl9w9 xrgqbfd x1s85apg xbh2guc" role="presentation"></span>

        <Link href={`/articles/${nextTheme}`}>
          <div {...{
        0: {
            className: "x78zum5 xh8yej3 x6s0dn4 x1ypdohk xl56j7k x14p003w xemqna3 xdpxx8g x15zctf7"
        },
        1: {
            className: "x78zum5 xh8yej3 x6s0dn4 x1ypdohk xl56j7k x14p003w xemqna3 x1hr2gdg x15zctf7"
        }
    }[!!isRTL << 0]}>
            <div className="x1ag4ua x196nufh">
              <FormattedMessage id="Next theme" defaultMessage="Next theme"/>
              <div {...stylex.props(typography.heading1, stylexStyles.title)}>{getThemeLabel(nextTheme)}</div>
            </div>
            {nextThemeStyle.kind === "article" && <img src={nextThemeStyle.illustration} alt="" className="x13oubkp x2sfjvx x1pqv317"/>}
          </div>
        </Link>
      </div>
    </div>;
};
